import { useState } from "react";
import { Link } from "react-router-dom";
import logo from "../assets/images/roster_connect_icon.png";
import "./LegalPage.css";

export default function RosterSupport() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="legal-root rc-legal">
      <header className="legal-header">
        <div className="legal-header-inner">
          <Link to="/roster-connect" className="legal-back">
            <img className="rc-logo-icon" src={logo} alt="Logo" />
            Roster Connect
          </Link>

          <button
            className={`legal-burger ${menuOpen ? "open" : ""}`}
            onClick={() => setMenuOpen((prev) => !prev)}
            aria-label="Toggle menu"
            aria-expanded={menuOpen}
          >
            <span />
            <span />
            <span />
          </button>

          <nav className={`legal-header-nav ${menuOpen ? "mobile-open" : ""}`}>
            <Link
              to="/roster-connect/privacy"
              onClick={() => setMenuOpen(false)}
            >
              Privacy Policy
            </Link>
            <Link to="/roster-connect/terms" onClick={() => setMenuOpen(false)}>
              Terms
            </Link>
            <Link
              to="/roster-connect/support"
              className="active"
              onClick={() => setMenuOpen(false)}
            >
              Support
            </Link>
          </nav>
        </div>
      </header>

      <main className="legal-main">
        <div className="legal-inner">
          <div className="legal-meta">
            <span className="legal-tag">Help Center</span>
          </div>

          <h1>Support</h1>
          <p className="legal-lead">
            Need help with Roster Connect? Whether you have questions about your
            account, technical issues, or feedback, I am here to assist you.
          </p>

          <section className="legal-section">
            <h2>Contact Me</h2>
            <p>
              For technical support or account inquiries, the fastest way to get
              help is via email. I usually respond within one business day.
            </p>
            <div
              className="legal-box"
              style={{ textAlign: "center", padding: "40px 20px" }}
            >
              <button
                className="rc-btn-primary"
                onClick={() =>
                  (window.location.href = "mailto:contact@crsoftware.dk")
                }
              >
                Email Support
              </button>
            </div>
          </section>

          <section className="legal-section">
            <h2>Quick FAQ</h2>

            <div className="faq-item" style={{ marginBottom: "30px" }}>
              <h4
                style={{
                  color: "var(--rc-red)",
                  marginBottom: "10px",
                  fontSize: "1.1rem",
                }}
              >
                How do I delete my data?
              </h4>
              <p>
                You can delete your entire account and all synced data directly
                in the app. Go to <strong>Settings</strong> and select{" "}
                <strong>Delete Account</strong>. This will permanently remove
                your account and all flight data from our systems.
              </p>
            </div>

            <div className="faq-item" style={{ marginBottom: "30px" }}>
              <h4
                style={{
                  color: "var(--rc-red)",
                  marginBottom: "10px",
                  fontSize: "1.1rem",
                }}
              >
                Missing flight information?
              </h4>
              <p>
                Ensure you are using the latest version of Roster Connect from
                the App Store. Airlines occasionally change their PDF formats;
                if your roster doesn't import correctly, please email the PDF to
                support so I can update the parser.
              </p>
            </div>

            <div className="faq-item">
              <h4
                style={{
                  color: "var(--rc-red)",
                  marginBottom: "10px",
                  fontSize: "1.1rem",
                }}
              >
                Subscription Issues?
              </h4>
              <p>
                Subscriptions are managed through your Apple ID. You can view,
                cancel, or change your subscription status in the iOS Settings
                app under your name.
              </p>
            </div>
          </section>
        </div>
      </main>

      <footer className="legal-footer">
        <div className="legal-footer-inner">
          <Link to="/roster-connect">← Back to Roster Connect</Link>
          <p>
            © {new Date().getFullYear()} Roster Connect. CR Software | CVR:
            46349180
          </p>
          <div className="legal-footer-links">
            <Link to="/roster-connect/privacy">Privacy Policy</Link>
            <Link to="/roster-connect/terms">Terms of Service</Link>
            <Link to="/">CR Software ApS</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
